import React, { useState } from "react";
import Styles from "./Element.module.css";
import TextInput from "../../../../commons/Inputs/TextInput/TextInput";

const TraderEntity = ({ userData, handleData, handleProceed }) => {
  const [formData, setFormData] = useState({
    entityConsumerName: userData?.traderEntity?.entityConsumerName || "",
    entityGeneratorName: userData?.traderEntity?.entityGeneratorName || "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => {
      const updated = { ...prev };
      delete updated[field];
      return updated;
    });
  };

  const validate = () => {
    const fieldErrors = {};
    if (!formData.entityConsumerName)
      fieldErrors.entityConsumerName = "Entity Consumer Name is required";
    if (!formData.entityGeneratorName)
      fieldErrors.entityGeneratorName = "Entity Generator Name is required";
    setErrors(fieldErrors);
    return Object.keys(fieldErrors).length === 0;
  };

  const handleContinue = () => {
    if (!validate()) return;
    handleData("traderEntity", formData);
    handleProceed("next");
  };

  return (
    <div className={Styles.elementMain}>
      <div className={Styles.displayInputSection}>
        <div className={Styles.conterntHeader}>Trader Entity</div>
        <div className={Styles.detailsInpMainContainer}>
          <div className={Styles.multiLayerContainer}>
            <div className={Styles.subConterntHeader}>Entity Details</div>
            <div className={Styles.layer2ElementsContainer}>
              <TextInput
                heading="Entity Consumer Name"
                value={formData.entityConsumerName}
                onChange={(value) => handleChange("entityConsumerName", value)}
                example="Enter Entity Consumer Name"
                height="45"
                error={errors.entityConsumerName}
              />
              <TextInput
                heading="Entity Generator Name"
                value={formData.entityGeneratorName}
                onChange={(value) => handleChange("entityGeneratorName", value)}
                example="Enter Entity Generator Name"
                height="45"
                error={errors.entityGeneratorName}
              />
            </div>
          </div>
        </div>
        <div className={Styles.buttonSection}>
          <div className={Styles.prevBtn} onClick={() => handleProceed("prev")}>
            Back
          </div>
          <div className={Styles.nextBtn} onClick={handleContinue}>
            Submit
          </div>
        </div>
      </div>
    </div>
  );
};

export default TraderEntity;
